// All entries lowercase — keys are normalized before lookup
const PII_FIELDS = new Set([
  'password',
  'email',
  'phone',
  'phonenumber',
  'firstname',
  'lastname',
  'token',
  'secret',
  'apikey'
]);

function scrubValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(scrubValue);
  }
  if (value !== null && typeof value === 'object') {
    return scrubPiiFields(value as Record<string, unknown>);
  }
  return value;
}

export function scrubPiiFields(obj: Record<string, unknown>): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj)) {
    if (PII_FIELDS.has(key.toLowerCase())) {
      result[key] = '[Redacted]';
    } else {
      result[key] = scrubValue(value);
    }
  }
  return result;
}
